module.exports = __webpack_public_path__ + "img/SOUTHASIA_CAKES_AND_PASTRIES.b37dd61b.png";